export const HOLIDAY_EVENTS = {
  birthday: "birthday",
  blackFriday: "blackFriday",
  halloween: "halloween",
  thanksGiving: "thanksGiving",
  christmas: "christmas",
  canadaDay: "canadaDay",
  independentDay: "independentDay",
  contestEarlyBirds: "contestEarlyBirds",
  contestBasic: "contestBasic",
  contestLastCall: "contestLastCall",
  contestLeaderboards: "contestLeaderboards",
  saintValentineDay: "saintValentineDay",
};

export const MONTHS = {
  JANUARY: 0,
  FEBRUARY: 1,
  MARCH: 2,
  APRIL: 3,
  MAY: 4,
  JUNE: 5,
  JULY: 6,
  AUGUST: 7,
  SEPTEMBER: 8,
  OCTOBER: 9,
  NOVEMBER: 10,
  DECEMBER: 11,
};

export const MILISECONDS_PER_HOURS = 3600000;
export const MILISECONDS_PER_MINUTES = 60000;
export const SECONDS_PER_MINUTE = 60;
export const HOURS_PER_DAY = 24;
export const MILISECOND_PER_SECOND = 1000;

export const HOLIDAY_EVENTS_DATE = {
  saintValentineDay: [
    { month: MONTHS.FEBRUARY, date: 7, hours: 8, minutes: 0, seconds: 0 },
    { month: MONTHS.FEBRUARY, date: 21, hours: 8, minutes: 0, seconds: 0 },
  ],
};
